module.exports = __webpack_public_path__ + "img/show.882e1aa4.svg";